/* eslint-disable max-statements */
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { navigate, useLocation } from '@reach/router'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { FluxosPagamentoProvider } from '../../../../contexts/FluxosPagamentoContext'
import { useGlobal } from '../../../../contexts/GlobalContext'
import { useModalidade } from '../../../../contexts/ModalidadeContext'
import { useRenovacaoPlano } from '../../../../contexts/RenovacaoPlanoContext'
import FluxosPagamento from '../../../../components/FluxosPagamento/FluxosPagamento'
import BreadcrumbGlobal from '../../../../components/BreadcrumbGlobal/BreadcrumbGlobal'
import { TIPO_PROMOCAO_RENOVACAO_PLANO } from '../../../../components/CupomPromocao/constantsPromocao'
import { FLUXOS_PAGAMENTO, PLANO_ANUAL, EVENTOS_GA, STATUS_CANCELADO, ROUTE_BASEPATH, INFORMACAO_MODALIDADES, MODALIDADE_INEDITOS, URLS, MODALIDADE_CURADORIA } from '../../../../constants'
import { isEmptyObject } from '../../../../utils/helpers/helpers'
import { DESCRICAO_PAGINA_RENOVACAO, LABEL_BOTAO_RENOVACAO, TITULO_PAGINA_RENOVACAO } from './constantsRenovacaoPlano'
import { tiposDePlanos } from '../../../../containers/Modalidade/Plano/constantsPlano'
import { TIPOS_FLUXO_BRINDES } from '../../../../components/FluxosPagamento/constantsFluxosPagamento'
import { getAssinaturaDoAssociadoPorModalidade, getInformacoesModalidadePorAssinatura } from '../../../../utils/helpers/helpersAssinatura'
import { URLS_APP } from '../../../../config'
import { STATUS_VALIDOS_ASSINATURAS_OPCIONAIS } from '../../../../containers/Opcionais/constantsCardOpcionais'
import { object } from 'prop-types'
import { getValorPlano } from '../../../../utils/helpers/helperPlano'
import { normalizeString } from '../../../../utils/formatter/formatter'
import { criarUsuarioLog, TIPOS_LOG_USUARIO } from '../../../../api/usuarioLog.servico'

const Titulo = styled.h1`
  margin: 25px 0 10px 0;
`

const SubTitulo = styled.h3`
  ${StyleGuide.tipografia.textoDefault};
  margin: 0;

  span {
    ${StyleGuide.boldFonte};
  }
`

const RenovacaoPlano = ( { location } ) => {
  const { dadosGlobaisAssociado, modalidadeURL, setFluxoGA, verifyAtMaintenance } = useGlobal()
  const { fetchPlanos, listaPlanosPorModalidade } = useModalidade()
  const {
    dadosRetornoRequisicao,
    loadingRequisicaoRenovacao,
    postRenovacaoPlano,
    sucessoRenovacao,
    setRenovarCombo,
    renovarCombo,
    setLoadingRequisicaoRenovacao,
  } = useRenovacaoPlano()
  const [ assinaturaModalidadeURL, setAssinaturaModalidadeURL ] = useState()
  const [ planosAssinaturaAssociado, setPlanosAssinaturaAssociado ] = useState()
  const visualizacaoInicialBreadcrumb = [ 'Entrega', 'Pagamento', 'Conclusão' ]
  const [ visualizacaoBreadcrumb, setVisualizacaoBreadcrumb ] = useState( visualizacaoInicialBreadcrumb )
  const [ brindesFluxo, setBrindesFluxo ] = useState( [] )
  const [ dadosDescontoCombo, setDadosDescontoCombo ] = useState( {} )
  const [ isCombo, setIsCombo ] = useState( null )
  const { state } = useLocation()
  const combo = state?.combo || null
  useEffect( () => {
    if ( combo ) {
      setRenovarCombo( true )
    }
  }, [ combo ] )

  useEffect( () => {
    setFluxoGA( EVENTOS_GA.RENOVACAO.FLUXO )
    criarUsuarioLog( TIPOS_LOG_USUARIO.INICIOU_CHECKOUT_ADA_RENOVACAO )
  }, [] )

  useEffect( () => {
    if ( dadosGlobaisAssociado && dadosGlobaisAssociado.assinaturas.length ) {
      const modalidadeIncluidaPathname = location.pathname.split( '/' ).find( path => {
        const infoModalidadeIncluidaNoPathname = INFORMACAO_MODALIDADES.find( modalidade => modalidade.slug === path )
        return !isEmptyObject( infoModalidadeIncluidaNoPathname )
      } )
      if ( isCombo === null ) {
        setIsCombo( dadosGlobaisAssociado?.assinaturas
          .filter( assinatura => STATUS_VALIDOS_ASSINATURAS_OPCIONAIS.includes( assinatura.status ) &&
            assinatura.controles.podeRenovar &&
            !assinatura.modalidade.temCobrancaBoletoPendente?.temCobrancaBoletoPendente &&
            !assinatura.modalidade.temCobrancaPixPendente?.temCobrancaPixPendente ).length === 2 )
      }
      let assinaturaPorModalidade
      if ( modalidadeIncluidaPathname ) {
        assinaturaPorModalidade = getAssinaturaDoAssociadoPorModalidade( dadosGlobaisAssociado.assinaturas, modalidadeIncluidaPathname )
      }
      let assinaturaRenovavel = {}
      if ( assinaturaPorModalidade && assinaturaPorModalidade.status !== STATUS_CANCELADO && assinaturaPorModalidade.controles.podeRenovar ) {
        assinaturaRenovavel = assinaturaPorModalidade
      }

      setAssinaturaModalidadeURL( assinaturaRenovavel )
    }
  }, [ dadosGlobaisAssociado, location ] )

  useEffect( () => {
    if ( modalidadeURL ) {
      fetchPlanos( modalidadeURL )
    }
  }, [ modalidadeURL ] )

  useEffect( () => {
    if ( !isEmptyObject( listaPlanosPorModalidade ) && modalidadeURL ) {
      const planosNaoPresente = listaPlanosPorModalidade[ tiposDePlanos.NAO_PRESENTE ]
      const planoAnual = planosNaoPresente.find( plano => plano.tipo === PLANO_ANUAL.visualizacao )
      if ( !isEmptyObject( planoAnual ) ) {
        const { id, tipo, valorTotal } = planoAnual
        setPlanosAssinaturaAssociado( {
          id,
          tipo,
          'valor': getValorPlano(
            assinaturaModalidadeURL,
            valorTotal,
            normalizeString( modalidadeURL ),
            'anual'
          )
        } )
      }
    }
  }, [ listaPlanosPorModalidade, modalidadeURL ] )

  const montarFluxoComBrindes = brindes => {
    if ( brindes.length > 1 ) {
      setBrindesFluxo( brindes )
      setVisualizacaoBreadcrumb( [ 'Entrega', 'Pagamento', 'Brinde', 'Conclusão' ] )
    }
  }

  const onPostRenovacaoPlano = async( dadosEtapas, setEtapaAtiva ) => {
    setLoadingRequisicaoRenovacao( true )
    const atMaintenance = await verifyAtMaintenance()

    if ( !isEmptyObject( dadosEtapas ) && !atMaintenance ) {
      postRenovacaoPlano(
        assinaturaModalidadeURL,
        dadosEtapas,
        setEtapaAtiva
      )
    } else {
      setLoadingRequisicaoRenovacao( false )
    }
  }

  if ( assinaturaModalidadeURL ) {
    if ( isEmptyObject( assinaturaModalidadeURL ) ) {
      if ( renovarCombo ) {
        const modalidade =
          modalidadeURL === MODALIDADE_CURADORIA.slug
            ? MODALIDADE_INEDITOS.slug
            : MODALIDADE_CURADORIA.slug
        navigate( `${ROUTE_BASEPATH}${URLS_APP.BASE_PATH ? '/' : ''}${modalidade}/${
          URLS.PLANO
        }/${URLS.RENOVAR_PLANO_ENTREGA}` )
      } else {
        navigate( `${ROUTE_BASEPATH}${URLS_APP.BASE_PATH ? '/' : ''}` )
      }
      return null
    } else {
      return (
        <div>
          <BreadcrumbGlobal
            exactPath="renovar-plano"
            nomeAlternativo="Renovação Plano"
            palavrasExcluidas={ /entrega|pagamento|brindes|conclusao/u }
          />

          <Titulo>{TITULO_PAGINA_RENOVACAO}</Titulo>

          <SubTitulo>{DESCRICAO_PAGINA_RENOVACAO}</SubTitulo>

          <FluxosPagamentoProvider
            descontoCombo={ setDadosDescontoCombo }
            fluxoPagamentoAtual={
              TIPOS_FLUXO_BRINDES[ FLUXOS_PAGAMENTO.RENOVACAO ]
            }
            idAssinaturaAtual={ assinaturaModalidadeURL.id }
            modalidadeParaBrinde={
              getInformacoesModalidadePorAssinatura( modalidadeURL ).id
            }
            montarFluxoComBrindes={ montarFluxoComBrindes }
          >
            <FluxosPagamento visualizacaoEtapas={ visualizacaoBreadcrumb }>
              <FluxosPagamento.Entrega
                planoExterno={ planosAssinaturaAssociado }
              />

              <FluxosPagamento.Pagamento />

              {brindesFluxo.length ? (
                <FluxosPagamento.Brindes brindesFluxo={ brindesFluxo } />
              ) : (
                []
              )}

              <FluxosPagamento.Conclusao
                concluirFluxo={ onPostRenovacaoPlano }
                dadosDescontoCombo={ dadosDescontoCombo }
                dadosRetornoRequisicao={ dadosRetornoRequisicao }
                fluxo={ FLUXOS_PAGAMENTO.RENOVACAO }
                fluxoTemPromocao
                idAssinatura={ assinaturaModalidadeURL.id }
                labelBotaoUltimaEtapa={ LABEL_BOTAO_RENOVACAO }
                loadingRequisicao={ loadingRequisicaoRenovacao }
                respostaRequisicao={ sucessoRenovacao }
                tipoAssinaturaPromocao={ TIPO_PROMOCAO_RENOVACAO_PLANO }
              />
            </FluxosPagamento>
          </FluxosPagamentoProvider>
        </div>
      )
    }
  }

  return null
}

RenovacaoPlano.propTypes = {
  'location': object.isRequired
}

export default RenovacaoPlano
